import React, { useRef, useState, useEffect, useCallback } from "react";
import { API_URL, FOLDERPATH } from "../Constants/config";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {getAutoLogin} from "../Actions/AutoLogin";


const LoginHelper = () => {

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loading } = autoLoginStore;
  const userVerificationCandidateStore = useSelector((state) => state.user);
  const { userData } = userVerificationCandidateStore;
  let newUser=JSON.parse(localStorage.getItem("userVerificationCandidate"));
  console.log("newUser",newUser);
  
  const [searchParams, setSearchParams] = useSearchParams();
  const tempToken = searchParams.get('token');
  const user_name = searchParams.get('username');
  const is_prepaid_client=searchParams.get('is_prepaid_client');
  const is_primary=searchParams.get('is_primary');
  const user_id=searchParams.get('user_id');
  const isAuth=searchParams.get('is_auth')
  const client_id=searchParams.get('client_id');
  const is_new_emp_form = searchParams.get('is_new_emp_form')

  useEffect(() => {
    if(isAuth==0){
      if (
        typeof autoLoginData?.status !== "undefined" &&
        autoLoginData?.status !== null
      ) {
         const refno=autoLoginData.data.reference_number
         navigate(
          `../../case-initiation/check-detail/${refno}/candidate-profile`
        );
      }

    }else{
      console.log(JSON.stringify(userData) + "21")
      if(userData?.data?.id){
      navigate("../candidate-form/authorization");
      }
    }
  }, [userData,autoLoginData, autoLoginStore])



  


  useEffect(() => {
    // let queryParameters = new URLSearchParams(window.location.search);
    //  tempToken = queryParameters.get("token");
    // let user_name = queryParameters.get("username")

    // let k = searchParams.get("token");
    // console.log(k);

    // console.log(queryString);

    let token = ''
    if(tempToken !== null){

      token = tempToken.split(' ').join('+');

      console.log(token);
      
      
      let userVerificationCandidate = {}
      userVerificationCandidate.id = token;
      userVerificationCandidate.user_name = user_name;
      userVerificationCandidate.is_prepaid_client=is_prepaid_client;
      userVerificationCandidate.is_primary=is_primary;
      userVerificationCandidate.user_id=user_id;
      userVerificationCandidate.client_id=client_id;
      userVerificationCandidate.is_new_emp_form = is_new_emp_form;
      localStorage.setItem('userVerificationCandidate' , JSON.stringify(userVerificationCandidate));
      
      
      localStorage.setItem('tempToken' , token);
      localStorage.setItem('user_name' , user_name);
      dispatch(getAutoLogin());
      let obj = { 
        data : {},
      };
      // let data = {};
      // obj.push(data);
      obj.data.id = tempToken;
      obj.data.user_name = user_name;
      console.log(obj)
      
      dispatch({
        type: 'USER_LOGIN_SUCCESS',
        payload: obj,
      });
    }

    // navigate("../dashboard");
    // window.location.href = "dashboard";


  }, [tempToken]);


  return (
    <div className="wrapper h-100vh">
    
    </div>
  );
};
export default LoginHelper;